interface TextWithLabelProps {
  value: string | number
  label: string
  className?: string
}

export const LabeledData = ({ value, label, className = '' }: TextWithLabelProps) => {
  return (
    <div className={`flex flex-col items-start ${className}`}>
      <span className="font-roboto font-semibold text-3xl">{value}</span>
      <span className="text-gray-500 text-sm">{label}</span>
    </div>
  )
}
